import { useState } from 'react';
import { Alert, Modal, Select, Spin } from 'antd';
import { TbShip } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import useGlobalVessel from './useGlobalVessel';
import { useAuth } from '../context/AuthContext';
import { getAlertsData } from '../Api/AlertData';
import { getDashboardData } from '../Api/DashboardData';
import PropTypes from 'prop-types';

export default function AlertVesselFilter({ dashboard = false }) {
    const [open, setOpen] = useState(false);
    const [vessels, setVessels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selection, setSelection] = useState(null);
    const vessel = useGlobalVessel();
    const navigate = useNavigate();
    const { user } = useAuth();
    const account = vessel?.accountId;
    const object = vessel?.objectCode;
    const load = async () => {
        setOpen(true); setLoading(true); setError(''); setSelection(vessel?.key || null);
        try { setVessels((await (dashboard ? getDashboardData('/vessels') : getAlertsData('/filters'))).vessels); }
        catch { setError('Unable to load vessel choices.'); }
        finally { setLoading(false); }
    };
    const apply = () => {
        const vessel = vessels.find(item => JSON.stringify([item.AccountId, item.ObjectCode]) === selection);
        if (!vessel) return;
        localStorage.setItem('Filter', JSON.stringify({ KodeCabang: vessel.AccountId, ShipCode: vessel.ObjectCode, ShipName: vessel.ShipName }));
        window.dispatchEvent(new CustomEvent('filterUpdated'));
        navigate(`?${new URLSearchParams({ KodeCabang: vessel.AccountId, ShipCode: vessel.ObjectCode })}`);
        setOpen(false);
    };
    return <>
        <button type="button" disabled={!dashboard && user?.role !== 'Admin'} onClick={load} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl bg-white/10 hover:bg-white/15 border border-white/15 text-left">
            <TbShip className="w-5 h-5 text-sky-300 shrink-0" /><div className="min-w-0"><p className="text-xs text-gray-400">VESSEL</p><p className="text-sm font-semibold truncate">{account && object ? `${account} / ${object}` : 'Select vessel'}</p></div>
        </button>
        <Modal title="Vessel context" open={open} onCancel={() => setOpen(false)} onOk={apply} okButtonProps={{ disabled: !selection || loading }}>
            <p className="text-sm text-slate-500 mb-4">This global vessel selection controls all {dashboard ? 'Dashboard' : 'Alerts & Events'} data and vessel navigation.</p>
            {loading ? <Spin /> : error ? <Alert type="error" message={error} /> : <Select aria-label="Sidebar vessel" className="w-full" showSearch optionFilterProp="label" value={selection} onChange={setSelection} placeholder="Select vessel" options={vessels.map(v => ({ value: JSON.stringify([v.AccountId, v.ObjectCode]), label: v.ShipName }))} />}
        </Modal>
    </>;
}
AlertVesselFilter.propTypes = { dashboard: PropTypes.bool };
